import { render, staticRenderFns } from "./ArticleFeedback.vue?vue&type=template&id=490f74e2&scoped=true&"
import script from "./ArticleFeedback.vue?vue&type=script&lang=js&"
export * from "./ArticleFeedback.vue?vue&type=script&lang=js&"
import style0 from "./ArticleFeedback.vue?vue&type=style&index=0&id=490f74e2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f74e2",
  null
  
)

/* custom blocks */
import block0 from "./ArticleFeedback.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports